export enum ControlActionTypes {
    InitShowLoginModal = 'InitShowLoginModal',
    InitShowRechargeModal = 'InitShowRechargeModal',
    InitLoginTitleTextArray = 'InitLoginTitleTextArray',
    InitShowShare = 'InitShowShare',
    InitShowRechargeQrcode = 'InitShowRechargeQrcode',
    InitRechargeQrcode = 'InitRechargeQrcode',
    InitRechargeOrderId = 'InitRechargeOrderId'
}


export const ActInitShowLoginModal = (payload: boolean) => ({
    type: ControlActionTypes.InitShowLoginModal,
    payload
})

export const ActInitShowRechargeModal = (payload: boolean) => ({
    type: ControlActionTypes.InitShowRechargeModal,
    payload
})

export const ActInitLoginTitleTextArray = (payload: string[]) => ({
    type: ControlActionTypes.InitLoginTitleTextArray,
    payload
})

export const ActInitShowShare = (payload: boolean) => ({
    type: ControlActionTypes.InitShowShare,
    payload
})

export const ActInitShowRechargeQrcode = (payload: boolean) => ({
    type: ControlActionTypes.InitShowRechargeQrcode,
    payload
})

export const ActInitRechargeQrcode = (payload: string) => ({
    type: ControlActionTypes.InitRechargeQrcode,
    payload
})

export const ActInitRechargeOrderId = (payload: string) => ({
    type: ControlActionTypes.InitRechargeOrderId,
    payload
})



export type ControlActions = ReturnType<typeof ActInitShowRechargeModal
    | typeof ActInitShowLoginModal
    | typeof ActInitLoginTitleTextArray
    | typeof ActInitShowShare
    | typeof ActInitShowRechargeQrcode
    | typeof ActInitRechargeQrcode
    | typeof ActInitRechargeOrderId
>
